import { Bitrix24Context } from 'contexts/legacy/Bitrix24Context';
import { identifyUser } from 'lib/mixpanel';
import { useContext, useEffect } from 'react';

// O ID do usuário do Bitrix24 só é único dentro do portal: o identificador combina os dois.
export function MixpanelIdentify() {
	const { user, domain } = useContext(Bitrix24Context);
	const userId = user?.ID;
	const email = user?.EMAIL ?? '';

	useEffect(() => {
		if (!userId || !domain) return;

		identifyUser({ distinctId: `${domain}:${userId}`, email, domain });
	}, [userId, email, domain]);

	return null;
}
